import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    justifyContent: "center",
    gap: theme.spacing.space8,
    width: "fit-content",
    alignItems: "center",
    background: theme.colors.background6,
    borderRadius: theme.radius.small,
  },
}));
